import { ModalManager } from '@findy-code/yuffie/shared/modal-manager';
import { ProductGlobalStyle } from '@findy-code/yuffie/ui/styles/product-global-style';
import type { ReactNode } from 'react';

import { LoginBannerComponent } from './components';
import { FooterComponent } from './footer/footer.component';
import { Header } from './header/header.component';
import styles from './layout.container.module.scss';

type Props = {
  children: ReactNode;
  isLogin?: boolean;
  isLoadingUserData?: boolean;
  isAccountEditPage?: boolean;
  isStepsProfilePage?: boolean;
  isWithoutFooter?: boolean;
  isWithBottomMargin?: boolean;
  isShowLoginButton?: boolean;
  isShowMobileNavigation?: boolean;
};

export const LayoutContainer = ({
  children,
  isLogin,
  isLoadingUserData,
  isAccountEditPage,
  isStepsProfilePage,
  isWithoutFooter,
  isWithBottomMargin,
  isShowLoginButton,
  isShowMobileNavigation,
}: Props) => {
  return (
    <>
      <ProductGlobalStyle />
      <ModalManager />
      <div
        className={
          isAccountEditPage
            ? styles.accountEditBlock
            : isStepsProfilePage
            ? styles.stepsProfileBlock
            : ''
        }
        data-testid={isLogin ? 'logged-in-main-wrap' : 'no-login-main-wrap'}
      >
        <Header
          isLogin={!!isLogin}
          isShowMobileNavigation={isShowMobileNavigation}
        />
        <main className={styles.main}>{children}</main>
        {!isWithoutFooter && (
          <FooterComponent isWithBottomMargin={isWithBottomMargin} />
        )}
        {isShowLoginButton && !isLoadingUserData && !isLogin && (
          <div style={{ paddingBottom: '150px' }}>
            <LoginBannerComponent />
          </div>
        )}
      </div>
    </>
  );
};
